<template>
  <ShortcutWrapper :nShortcutRequiredClaim="UserClaims.GlobalAdmin" @n-shortcut="mutate(null, 'create')">
    <v-container fluid id="grade-settings">

      <Dialog
      :stateId="dialogId"
      maxWidth="400px"
      @click:outside="close"
      @dialog-closing="close"
      @close="close">

        <ConfirmDelete
        v-if="deleting"
        :title="$t('grade')"
        @delete="performDelete"
        @cancel-delete="close"/>

        <GradeForm
        v-else
        :propGrade="grade"
        @grade-mutated="refresh"/>

      </Dialog>

      <DataTable
      defaultHeight="calc(100vh - 620px)"
      :items="allGrades"
      :headers="headers"
      :customCells="customCells"
      :actions="tableActions"
      :loading="gradesLoading"
      :showDense="false"
      @refresh="refresh"
      @new-grade="mutate(null, 'create')"
      style="max-width: 1000px;">

        <template #actions="{ item }">
          <Icon
          icon="mdi-pencil"
          :tooltipText="$t('edit')"
          @icon-clicked="mutate(item, 'edit')"
          :disabled="!userAssignedClaim(UserClaims.GlobalAdmin)"
          elementId="grade-edit"/>

          <Icon
          icon="mdi-delete-forever"
          :tooltipText="$t('delete')"
          @icon-clicked="mutate(item, 'delete')"
          :disabled="!userAssignedClaim(UserClaims.GlobalAdmin)"
          elementId="grade-delete"/>
        </template>

      </DataTable>

    </v-container>
  </ShortcutWrapper>
</template>
<script>
import ProductHeaders from '@/headers/Product'
import { userAssignedClaim } from '@/utils/ClaimUtility'
import { UserClaims } from '@/utils/Enumerations.js'
import { uniqueDialogId } from '@/utils/componentHelpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GradeSettings',

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    ShortcutWrapper: () => import('@/components/core/ShortcutWrapper.vue'),
    Dialog: () => import('@/components/Dialog.vue'),
    Icon: () => import('@/components/helper/Icon.vue'),
    GradeForm: () => import('@/components/settings-components/product-settings/grade/GradeForm.vue'),
    ConfirmDelete: () => import('@/components/helper/ConfirmDelete.vue')
  },

  data: () => ({
    UserClaims,
    dialogId: uniqueDialogId('grade-dialog'),
    deleting: false,
    grade: null
  }),

  async mounted () {
    await this.fetchGrades()
  },

  computed: {
    ...mapGetters('grade', ['allGrades', 'gradesLoading']),
    headers () {
      return ProductHeaders.gradeHeaders()
    },

    tableActions () {
      return [
        {
          icon: 'mdi-refresh',
          text: this.$t('refresh'),
          actionName: 'refresh'
        },
        {
          icon: 'mdi-plus',
          text: this.$t('newGrade'),
          actionName: 'new-grade',
          disabled: !userAssignedClaim(UserClaims.GlobalAdmin)
        }
      ]
    },

    customCells () {
      return [
        {
          slotName: 'actions',
          value: 'actions'
        }
      ]
    }
  },

  methods: {
    ...mapActions('dialog', ['openOrUpdateDialog', 'closeDialogsAtOrAbove']),
    ...mapActions('grade', ['fetchGrades', 'deleteGrade']),
    userAssignedClaim,

    refresh () {
      this.close()
      this.loading = true
      this.fetchGrades().finally(() => {
        this.loading = false
      })
    },

    mutate (grade, mutationType) {
      this.grade = JSON.parse(JSON.stringify(grade))
      if (mutationType === 'delete') this.deleting = true
      this.openOrUpdateDialog(this.dialogId)
    },

    close () {
      this.deleting = false
      this.closeDialogsAtOrAbove(this.dialogId)
      this.grade = undefined
    },

    async performDelete () {
      await this.deleteGrade(this.grade.gradeId)
      this.refresh()
    }
  }
}
</script>
